import { EllipsisVerticalIcon } from "lucide-react"
import { useEffect, useState } from "react"
import { Card, OverlayTrigger, Popover, Tooltip } from "react-bootstrap"
import { PortAlerts } from "../hooks/portAlertsService"
import { usePrevetTabStateContext } from "../hooks/prevetContext"
import { VesselStay } from "../hooks/useFetchVesselStays"
import { usePortAlerts } from "../hooks/usePortAlerts"

function PrevetPortAlertWidget({
  vesselStays,
}: {
  vesselStays: VesselStay[] | undefined
}) {
  const [chosenOrganization, setChosenOrganization] = useState("")
  const {
    portAlerts: paPortAlerts,
    chosenOrganization: paChosenOrganization,
    portAlertsVesselStays,
  } = usePortAlerts({ org_ids: [chosenOrganization] })

  useEffect(() => {
    if (paChosenOrganization) {
      setChosenOrganization(paChosenOrganization.id)
    }
  }, [paChosenOrganization, vesselStays, paPortAlerts])

  const {
    isPortAlertAdmin,
    setShowPortAlertModal,
  } = usePrevetTabStateContext()

  const renderTooltipPortAlerts = () => {
    return (
      <Popover id="popover-basic">
        <Popover.Body>According to AIS - WOG. Data since 2021.</Popover.Body>
      </Popover>
    )
  }

  const renderTooltip = (props: any) => (
    <Tooltip id="edit-tooltip" {...props}>
      Edit port alerts
    </Tooltip>
  )

  const portAlertsVessel = portAlertsVesselStays(
    vesselStays ?? ([] as VesselStay[]),
    paPortAlerts ?? ([] as PortAlerts)
  )

  return (
    <>
      <Card className="PrevetContainer_PortAlerts">
        <Card.Body>
          <div className="w-100 d-flex justify-content-between">
            <div className="d-flex">
              <Card.Title>Port Alerts </Card.Title>
              <OverlayTrigger
                placement="top"
                overlay={renderTooltipPortAlerts()}
              >
                <i
                  className="ti-info-alt ms-1"
                  style={{ position: "relative", fontSize: "0.65rem" }}
                />
              </OverlayTrigger>
            </div>
            {isPortAlertAdmin && (
              <div className="d-flex gap-1">
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip}
                >
                  <EllipsisVerticalIcon
                    style={{ height: "20px", cursor: "pointer" }}
                    onClick={() => setShowPortAlertModal(true)}
                    className="hide-on-small-screen"
                  />
                </OverlayTrigger>
              </div>
            )}
          </div>

          <div
            className="text-muted w-100 text-left mt-3"
            style={{ height: "135px", overflowY: "auto" }}
          >
            {portAlertsVessel?.length === 0 ? (
              <p> "No port alerts found."</p>
            ) : (
              portAlertsVessel?.map((pa, i) => {
                return (
                  <div key={i} className="d-flex justify-content-between">
                    <div>{i + 1 + ". " + pa.port}</div>
                    <div className="hide-on-small-screen">{pa.date_from}</div>
                  </div>
                )
              })
            )}
          </div>
        </Card.Body>
      </Card>
    </>
  )
}

export default PrevetPortAlertWidget
